import { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import Translation from "../../translation/translation.component";
import ListOneColumn from "./list-one-column.component";
class CustomizableOneColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
        show: false,
        isSaving: false,
        clearData: false,
        selectedCols: [],
        originalOrder: [],
    };
  }

  handleClose(){
    this.setState({
        show: false,
        isSaving: false
    });
  }

  handleShow() {
      const originalOrder = this.props.firstList ?? [];
      this.setState({
          show: true,
          originalOrder: originalOrder.map(i => i.FilterId),
          selectedCols: originalOrder,
      });
  }

  onSelectedChange(selected) {
      this.setState({selected:selected})
  }

  onChange = (selected) => {
      this.setState({ selected });
  };

  resetDefault() {   
      this.setState({clearData:true});
  }

  
  resetClearData(item) {
      this.setState({clearData:item})
  }

  secondList = () => {
       var secondList = this.props.secondList ?? [];
       var selected = this.state.selected ?? [];
        return [
            ...secondList,
            ...selected
        ];
  }

  handleSelectedCols = (selectedCols) => {
        this.setState({
            selectedCols: selectedCols
        });
  }

  hasChangedOrder = () => {
        const { originalOrder, selectedCols } = this.state;
        const currentOrder = selectedCols.map(i => i.FilterId);
        return (
            originalOrder.length !== currentOrder.length ||
            originalOrder.some((id, index) => id !== currentOrder[index])
        );
  };

  async saveSelectedCols() {
        const { saveAction } = this.props;
        const { selectedCols } = this.state;
        
        this.setState({
            isSaving: true
        });

        if(saveAction) {
            await saveAction(selectedCols);
        }
       
        this.handleClose();
  }

  render() {
   const {show,clearData,isSaving }=this.state;
   const { linkLabel, modalTitle, isLinkDisabled } = this.props;
   const disableSave = !this.hasChangedOrder(); 
    return (
      <>
            <span className={`custom-link_style mt-17 ${isLinkDisabled ? 'disabled' : ''}`} onClick={isLinkDisabled ? '' : this.handleShow.bind(this)} >{linkLabel}</span>
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container custom-one-column-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListOneColumn firstList={this.props.firstList ?? []}  defaultList={this.props.defaultList} resetFilter={clearData} resetClearData={this.resetClearData.bind(this)} handleSelectedData={this.handleSelectedCols}/>
        </Modal.Body>
        <Modal.Footer>
        <div className="btn-tooltiptext">
               <Button variant="secondary" onClick={this.handleClose.bind(this)} disabled={isSaving}>
                        <Translation translationKey="cancel_button" />
               </Button>
               <span className="tooltip-text"><Translation translationKey={"cancel_button"} /></span>
        </div>
        <div className="btn-tooltiptext">
               <Button variant="primary" onClick={() => this.saveSelectedCols()} disabled={isSaving || disableSave}>
                        <Translation translationKey="call_save" />
               </Button>
               <span className="tooltip-text"><Translation translationKey={"save_order_column"} /></span>
        </div>
        </Modal.Footer>
      </Modal>

      </>
    );
  } 
}

export default CustomizableOneColumn;